/**
 * @generated SignedSource<<37eab354ffef704063d36bf755f8ce5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef";
};
export type sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef$key = {
  readonly " $data"?: sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "sprint_issueFieldSprintInlineEditFull_SprintInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraSprintField"
};

(node as any).hash = "aba26260bac1c5d276c6291d7046e952";

export default node;
